import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type UIScale = 80 | 85 | 90 | 95 | 100

interface ScaleState {
  scale: UIScale
  setScale: (scale: UIScale) => void
  initScale: () => void
}

const applyScale = (scale: UIScale) => {
  if (typeof document === 'undefined') return
  document.documentElement.style.fontSize = `${scale}%`
}

export const useScaleStore = create<ScaleState>()(
  persist(
    (set, get) => ({
      scale: 100,

      setScale: (scale) => {
        applyScale(scale)
        set({ scale })
      },

      initScale: () => {
        applyScale(get().scale)
      },
    }),
    {
      name: 'vision-scale',
      partialize: (state) => ({ scale: state.scale }),
    }
  )
)
